import * as TermsOfServiceDocumentUploads from "$lib/data/generated/uploads/terms of service/Document/uploads.js";

export const uploads = {
  ...TermsOfServiceDocumentUploads.uploads
};
